<template>
  <div class="page fp-viewing-contest">
    <curtains>
      <fixed-blocks v-if="this.$mq !== 'mobile'"></fixed-blocks>
      <navigation v-if="this.$mq !== 'mobile'"></navigation>
      <fixed-blocks-mobile v-if="this.$mq === 'mobile'">
        <navigation></navigation>
      </fixed-blocks-mobile>
      <gallery :images="images" :index="index" @close="closeGallery"></gallery>
      <h1 class="pageHeader">
        Галерея
      </h1>
      <div class="gallery">

        <div v-for="(image, imageIndex) in data"
             v-bind:style="{'background-image': 'url(' + apiHost + image.image_url + ')'}"
             class="image"
             @click="index = imageIndex">
          <div class="user-data">
            <div v-bind:style="{ 'background-image': 'url(' + apiHost + image.author.image_url + ')' }"
                 class="user-image">
            </div>
            <div class="user-text">{{(image.author.full_name?image.author.full_name:"@"+image.author.username)}}</div>
          </div>
        </div>
      </div>
    </curtains>
  </div>
</template>

<script>
    import EventBus from '../event-bus.js';
    import Navigation from '../components/common/Navigation.vue';
    import axios from 'axios';
    import VueGallery from 'vue-gallery';
    import Curtains from '../components/common/Curtains';
    import fixedBlocks from '../components/common/fixedBlocks';
    import fixedBlocksMobile from '../components/common/fixedBlocksMobile';

    export default {
        name: "Gallery",
        metaInfo: {
            title: 'Галерея',
        },
        methods:{
            closeGallery(){
                this.index = null;
                if (this.winners){
                    this.$router.push({ name: 'winners',params: {id: this.winnerId}})
                }
            }
        },
        components: {
            Navigation,
            Curtains,
            fixedBlocks,
            fixedBlocksMobile,
            'gallery': VueGallery
        },
        data() {
            return {
                apiHost: 'https://grabber.4m9fka.ru/',
                images: [],
                data: [],
                errored: false,
                index: null,
                winners:false,
                winnerId:null,


            }
        },
        mounted() {
            let imageId = this.$route.params.id;
           this.winnerId = this.$route.params.winner;

            axios.get(this.apiHost + "api/get-images",
                {
                    'Access-Control-Allow-Origin': '*',
                    'Content-Type': 'application/json',
                })
                .then(response => {
                    for (let image of response.data) {
                        this.images.push(this.apiHost + image.image_url);
                    }
                    this.data = response.data;
                    if (imageId) {
                       let index =  this.data.reduce(function (previousValue, currentValue, currentIndex, array) {
                            if (currentValue.id == imageId) {
                                return  currentIndex;;
                            }
                            return previousValue
                        });
                       if (index){
                           this.index = index;
                           this.winners = true;
                       }
                    }
                    EventBus.$emit('end-loading')
                })
                .catch(error => {
                    this.errored = true;
                    EventBus.$emit('end-loading')
                })

        }
    }
</script>

<style scoped lang="scss">
  @import "../assets/scss/mixins";

  .page {
    display: block;
    width: 100%;
    min-height: 100vh;
    height: 100%;
    position: relative;
    background: #0d8987;
    overflow: auto;
  }

  .pageHeader {
    color: #ffffff;
    font-size: 60px;
    font-weight: 700;
    line-height: 89px;
    text-align: center;
    margin: 55px auto 26px;

    @include breakpoint(mobile) {
      font-size: 30px;
      font-weight: 700;
      line-height: 44px;
      margin-top: 18vmin;
    }
  }

  .gallery {
    width: 95%;
    max-width: 950px;
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    margin: 0 auto;
    position: relative;
    z-index: 300;
    padding-bottom: 100px;
    @include breakpoint(mobile) {
      z-index: 197;
      width: 80%;
      margin: 0 auto;
    }
    .image {
      margin: 5px;
      width: calc(25% - 10px);
      background-size: cover;
      position: relative;
      overflow: hidden;
      @include breakpoint(mobile) {
        width: calc(100% - 20px);
      }
      &:after {
        content: "";
        display: block;
        padding-bottom: 100%;
      }
      .user-data {
        opacity: 0;
        transform: translateY(20px);
        transition: all ease-in-out 100ms;
        position: absolute;
        bottom: 10px;
        left: 5%;
        width: 90%;
        height: 30%;
        display: flex;
        overflow: hidden;
        align-items: center;
        @include breakpoint(mobile) {
          opacity: 1;
          transform: translateY(0);
        }
        .user-image {
          background-size: cover;
          border-radius: 50%;
          width: 50px;
          height: 50px;
          flex-shrink: 0;
          border: white solid 2px;
        }
        .user-text {
          text-align: left;
          margin-left: 10px;
          font-size: 16px;
          text-shadow: 0 0 10px rgba(0, 0, 0, 0.9);
          overflow: hidden;
        }
      }
      &:hover {
        .user-data {
          opacity: 1;
          transform: translateY(0);
        }
      }
    }
  }


</style>